import React from 'react';
import Box from '@mui/material/Box';
import { useStyles as useStylesSpinner } from 'src/components/FilterSpinner/components/TypeDisplayedSpinner/styles-spinner';
import { useStyles as useStylesCrossTable } from 'src/components/FilterSpinner/components/TypeDisplayedSpinner/styles-crosstable';
import { useBuildType } from 'src/hooks';
import { useSelector } from 'react-redux';
import { requestSelectors } from 'src/store/requests/selectors';
import { IWrapperMobileItem } from './types';

export const WrapperMobileItem: React.FC<IWrapperMobileItem> = ({
  isActive,
  iconItem,
  text,
  handleClick,
}) => {
  const { isSpinner } = useBuildType();
  const mainColor = useSelector(requestSelectors.app.getMainColors);
  const stylesSpinner = useStylesSpinner(mainColor);
  const stylesCrossTable = useStylesCrossTable();
  const styles = isSpinner ? stylesSpinner : stylesCrossTable;

  return (
    <Box
      className={`${styles.wrapperTypeItem} ${isActive ? styles.selectedStyle : ''}`}
      onClick={handleClick}
    >
      <div className={styles.iconTypeStyles}>
        {iconItem}
      </div>
      <span>{text}</span>
    </Box>
  );
};
